import { Filter } from "@/models/Pageable"

export class FilterSearchItem extends Filter {
  q = ""
  projectIds: string[] = []
  timesheetsEnabled?: boolean
  projectName?: string

  constructor(props?: Partial<FilterSearchItem>) {
    super(props as Filter)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
    this.empty = true
  }

  getJsonObj() {
    const data = {
      q: this.q,
      projectIds: this.projectIds,
      timesheetsEnabled: this.timesheetsEnabled
    }

    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterSearchItem(props)
  }

  static createDefault() {
    const props = {
      q: "",
      projectIds: []
    }

    const filter = new FilterSearchItem(props)
    return filter
  }
}
